export default "<ion-button\n*ngIf=\"visible\" \n(click)=\"onClick()\"\n>Guardar</ion-button>";